import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';

export const ParticipantBehaviourCreateButton = (props: ChakraV3.ButtonProps) => {
  return (
    <ChakraV3.Button
      w='full'
      h='full'
      rounded='2xl'
      variant='outline'
      borderWidth='2px'
      borderStyle='dashed'
      color='gray.400'
      bg='white'
      _hover={{
        borderColor: 'gray.400',
        color: 'gray.500',
      }}
      fontSize='2xl'
      {...props}
    >
      <FaPlus />
      Add behaviour
    </ChakraV3.Button>
  );
};
